import { render, staticRenderFns } from "./LocationDetails.vue?vue&type=template&id=356f52fe&scoped=true&"
import script from "./LocationDetails.vue?vue&type=script&lang=ts&"
export * from "./LocationDetails.vue?vue&type=script&lang=ts&"
import style0 from "./LocationDetails.vue?vue&type=style&index=0&id=356f52fe&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356f52fe",
  null
  
)

export default component.exports